"use client";

import { useEffect } from "react";

import { normalizeReferralCode, setCookie } from "@/app/_lib/referral-utils";

export function ReferrerHandler() {
  useEffect(() => {
    // Handle referrer ID from OAuth callback URL
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get("ref");

    if (ref) {
      const normalized = normalizeReferralCode(ref);

      // Store new cookie name + legacy cookie for backward compatibility.
      setCookie("referralCode", normalized, 60 * 60 * 24 * 30);
      setCookie("referrerId", normalized, 60 * 60 * 24 * 30);

      // Clean up the URL by removing the ref parameter
      const url = new URL(window.location.href);
      url.searchParams.delete("ref");
      window.history.replaceState(
        {},
        document.title,
        url.pathname + url.search,
      );
    }
  }, []);

  return null; // This component doesn't render anything
}
